import React from "react";
import { v4 as uuidv4 } from "uuid";
import { Tooltip } from "./Tooltip";
export var Descriptor = function (_a) {
    var message = _a.message, _b = _a.icon, icon = _b === void 0 ? "info-sign" : _b, _c = _a.color, color = _c === void 0 ? "#757575" : _c, _d = _a.placement, placement = _d === void 0 ? "top" : _d;
    return (React.createElement(Tooltip, { content: message, placement: placement, iconShown: false, tooltipId: uuidv4() },
        React.createElement("span", { className: "descriptor-icon glyphicon glyphicon-".concat(icon), style: { color: color } })));
};
